<template>
	<div class="about">
		<img class="wow fadeIn" style="width: 100%;" src="../../assets/mobile/businessBg.jpg" />
		<div class="mainArea ">
			<div class="threeGod flexBtw wow fadeIn">				
				<div class=""><img src="../../assets/three_1.png" />
					<div>精品内容</div>
				</div>
				<div class="lightBoxImportant"><img src="../../assets/three_2.png" />
					<div>娱乐新空间</div>
				</div>
				<div class=""><img src="../../assets/three_3.png" />
					<div>数字营销</div>
				</div>
			</div>
			<div class="threeGod2">
				<div class="lightBox wow fadeIn">
					<p class="a">深耕<label class="b">娱乐新空间</label>运营</p>
					<p class="a">并在上下游布局<label class="b">内容投资</label>和<label class="b">数字营销</label></p>
				</div>
			</div>
		</div>
		<div style="margin-top:20px;position: relative;padding-bottom: 10px;" class="mainArea">
			<div class="itemBox" ref="demo2">
				<div class="itemBox_b">
					<el-carousel trigger="click" :height="mheight" :interval='5000' ref="carousel2" class="carousel2">
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_3.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_4.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img  class="itemBox_bimg" src="../../assets/team2_0.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img  class="itemBox_bimg" src="../../assets/team2_4.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img  class="itemBox_bimg" src="../../assets/team2_1.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img  class="itemBox_bimg" src="../../assets/team2_2.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img  class="itemBox_bimg" src="../../assets/team2_3.jpg" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="itemBox_a">
					<div class="title ">娱乐新空间</div>
					<div class="info ">“体验经济”时代，基于特定物理空间的娱乐业态迎来爆发机遇<br>
						当前聚焦传统电影院向演艺新空间、VR剧院的发展<br>
						持续产品迭代，致力于服务更广阔的商业、文化空间和城市更新
					</div>
				</div>
			</div>
			<div class="itemBox" ref="demo1">
				<div class="itemBox_b" ref="itemBox_bref">
					<el-carousel  :height="mheight" ref="carousel1" class="carousel1">
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_1.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_2.jpg" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="itemBox_a">
					<div class="title">精品内容</div>
					<div class="info">内容为王<br>
						提升投资回报率，挖掘优质IP的长期价值<br>
						自微短剧、儿童剧等细分市场切入重点发力VR内容
					</div>
				</div>
			</div>			
			<div class="itemBox" ref="demo3">
				<div class="itemBox_b">
					<el-carousel trigger="click" :height="mheight" :interval='4000' ref="carousel3" class="carousel3">
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_5.jpg" />
						</el-carousel-item>
						<el-carousel-item>
							<img class="itemBox_bimg" src="../../assets/team_6.png" />
						</el-carousel-item>
					</el-carousel>
				</div>
				<div class="itemBox_a">
					<div class="title">数字营销</div>
					<div class="info">服务于精品内容发行、为娱乐新空间引流<br>
						继续发挥互联网票务、数字营销等传统业务优势<br>
						战略性布局AI营销
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		WOW
	} from 'wowjs'
	export default {
		name: 'Home',
		data() {
			return {
				mheight: '282px',
				pcShow: true
			}
		},
		
		created() {
			let isM=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
			if(!isM){
				this.$router.push({ path: '/pc/business'});
			}
			
		},
		methods:{
			scrollToElement(name) {
			  const element = this.$refs[name];
			  if (element) {
			    const rect = element.getBoundingClientRect();
			    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			    const targetPosition = rect.top + scrollTop - 100; // 减去100px作为偏移
			    
			    window.scrollTo({
			      top: targetPosition,
			      behavior: 'smooth'
			    });
			  }
			},
			slideBanner(id) {
				//选中的轮播图
				var box = document.querySelector('.'+id+' .el-carousel__container');
				var startPoint = 0;
				var stopPoint = 0;
				//重置坐标
				var resetPoint = function() {
					startPoint = 0;
					stopPoint = 0;
				}
				console.log('======',box)
				//手指按下
				box.addEventListener("touchstart", function(e) {
					//手指点击位置的X坐标
					startPoint = e.changedTouches[0].pageX;
				});
				//手指滑动
				box.addEventListener("touchmove", function(e) {
					//手指滑动后终点位置X的坐标
					stopPoint = e.changedTouches[0].pageX;
				});
				//当手指抬起的时候，判断图片滚动离左右的距离
				let that = this
				box.addEventListener("touchend", function(e) {
					console.log("1：" + startPoint);
					console.log("2：" + stopPoint);
					if (stopPoint == 0 || startPoint - stopPoint == 0) {
						resetPoint();
						return;
					}
					if (startPoint - stopPoint > 0) {
						resetPoint();
						that.$refs[id].next();
						return;
					}
					if (startPoint - stopPoint < 0) {
						resetPoint();
						that.$refs[id].prev();
						return;
					}
				});
			},
		},
		mounted() {
			const that = this
			if (window.innerWidth <= 800) {
				this.pcShow = false
			}
			const divWidth = this.$refs.itemBox_bref.offsetWidth;
			this.mheight = 410 * divWidth / 570 + 'px'
			this.slideBanner('carousel1')
			this.slideBanner('carousel2')
			this.slideBanner('carousel3')
			this.$nextTick(() => {
				let demoType=that.$route.query.demoType
				if(demoType){
					setTimeout(()=>{
						that.scrollToElement('demo'+demoType)
					},500)
				}				
				const wow = new WOW({
					boxClass: 'wow',
					animateClass: 'animated',
					offset: 0,
					mobile: true,
					live: true,
				})
				wow.init()
			})
		}
	}
</script>
<style lang="less" scoped>
	.about {
		background: #000;
	}
	.lightBoxImportant{
		background: #FB5400;
		padding: 20px;
		border-radius: 5px;
	}
	.lightBoxImportant2{
		border:1px solid #777;
		padding: 20px;
		border-radius: 5px;
	}
	.threeGod {
		margin: 30px auto;
		width: 300px;
		color: #fff;
		font-size: 14px;
		font-weight: bold;
		img {
			height: 30px;
			margin-bottom: 10px;
		}
	}

	.lightBox {
		position: relative;
		overflow: hidden;
	}

	.light-1 {
		position: absolute;
		z-index: 0;
		width: 1000px;
		height: 1000px;
		border-radius: 50%;
		filter: blur(80px);
		animation: moveAround 10s linear infinite;
		background: rgba(106, 0, 255, 0.4);
		top: 10px;
		left: calc(50% - 500px);
		animation-delay: 0s;
	}

	.itemBox {
		background: #fff;
		margin-bottom: 30px;
		.itemBox_a {
			width: 100%;
			padding: 20px;
			text-align: left;
			.title {
				color: #333;
				font-size: 20px;
				margin-bottom: 10px;
			}
			.info {
				line-height: 30px;
				color: #777;
				font-size: 14px;
			}
		}

		.itemBox_b {
			width: 100%;
			min-height: 282px;
			.itemBox_bimg {
				width: 100%;
				height: auto;
				background: darkblue;
			}
		}
	}

	.threeGod2 {
		position: relative;
		padding-top: 30px;
		border-top: 1px solid #333;
		width: 100%;
		background: url('../../assets/Polygon 1.png') no-repeat top center;
		background-size: 100% auto;
		.a {
			line-height: 50px;
			font-size: 20px;
		}

		.b {
			color: #FB5400;
			font-size: 18px;
			margin-top: 20px;
		}
	}
	
</style>